export default "__VITE_ASSET__DVTfPsn9__"